'use client';

import { type FC } from 'react';
import { useTranslations } from 'next-intl';

import {
  getUserAvatarInitials,
  getUserAvatarName,
  useUserState,
} from '@entities/user';

import {
  Avatar,
  Box,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
} from '@shared/ui-kit';

interface Props {
  onSignOut: () => void;
}

const UserMenu: FC<Props> = ({ onSignOut }) => {
  const t = useTranslations('General');
  const { user, status } = useUserState();

  if (status === 'initializing') return <Spinner size="md" />;

  if (!user) return null;

  return (
    <Box className="no-print">
      <Menu>
        <MenuButton
          display="block"
          cursor="pointer"
        >
          <Avatar
            size="sm"
            name={getUserAvatarName(
              `${user.last_name} ${user.first_name} ${user.patronymic}`,
              user.id,
            )}
            getInitials={getUserAvatarInitials}
          />
        </MenuButton>
        <MenuList zIndex="dropdown">
          <MenuItem onClick={onSignOut}>{t('signOut')}</MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default UserMenu;
